'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('filingMobileDetailController', function(docketService, userService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {
    /***************************/
    /***** Setup Variables *****/
    /***************************/

    $scope.moment = moment;
    $scope.viewState = 'docket';

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    /**********************/
    /**** Permissions *****/
    /**********************/

    $scope.userHasPermission = function(permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.userCanDoAction = userService.userCanDoAction;

    $scope.openMenu = function($mdOpenMenu, ev) {
      //originatorEv = ev;
      $mdOpenMenu(ev);
    };

    /*************************************/
    /***** Docket Filing Detail View *****/
    /*************************************/

    $scope.openDocketForFiling = function(docketId) {
      $scope.viewState = 'filing';
      docketService.getDocket(docketId, false, function(fullDocket) {
        var docketsList = [];
        docketsList.push(fullDocket);
        $scope.openBulkDocketsForFiling(docketsList);
      }, function(err) {
        $scope.alertService.presentAutoAlert('openDocketFiling', err);
        $scope.closeDocketFiling();
      });
    }

    $scope.openBulkDocketsForFiling = function(docketsList) {
      $scope.viewState = 'filing';
      $scope.prepareForFilingFromParent();
      // Get full versions of all selected dockets
      $scope.populateDocketFiles(docketsList, function(docketsListPopulated) {
        $scope.loadBulkDocketsFromParent(docketsListPopulated);
      });
    }

    $scope.closeDocketFiling = function() {
      var stateBack = {};
      if ( $stateParams.stateTrail && $stateParams.stateTrail.length > 0 ) {
        stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 1];
      }
      var stateOptions = {};
      if ( stateBack.orderId ) {
        stateOptions.orderId = stateBack.orderId;
      }
      if ( stateBack.jobId ) {
        stateOptions.jobId = stateBack.jobId;
      }
      if ( stateBack.docketId ) {
        stateOptions.docketId = stateBack.docketId;
      }
      if ( stateBack.fromTab ) {
        stateOptions.openTab = stateBack.fromTab;
      }
      if ( stateBack.orgId ) {
        stateOptions.orgId = stateBack.orgId;
      }
      if ( stateBack.groupId ) {
        stateOptions.groupId = stateBack.groupId;
      }
      if ( stateBack.name ) {
        $state.go(stateBack.name, stateOptions);
      } else {
        $state.go('main.groupFiling', {orgId:$scope.currentOrg.id, groupId:$scope.currentOrgGroup.id});
      }
    }

    $scope.saveDocketFiling = function(docketFiling) {
      docketFiling.loading = true;
      docketService.saveDocketFiling(docketFiling, function(success) {
        $scope.closeDocketFiling();
      }, function(err) {
        docketFiling.loading = false;
        $scope.alertService.presentAutoAlert('saveDocketFiling', err);
      });
    }

    /**************************/
    /***** Modal Controls *****/
    /**************************/

    /*******************************/
    /***** Docket Data Helpers *****/
    /*******************************/

    $scope.populateDocketFiles = function(docketList, cb) {
      var index = 0;
      $scope.populateDocketListWithFiles(docketList, index, function() {
        cb(docketList);
      });
    };

    $scope.populateDocketListWithFiles = function(docketList, index, cb) {
      if ( index >= docketList.length ) {
        cb();
        return;
      }

      // populate this index of the docketList
      $scope.populateDocketFileData(docketList[index], function(){
        // go to next index
        $scope.populateDocketListWithFiles(docketList, index + 1, cb);
      });
    }

    $scope.populateDocketFileData = function(docket, cb) {
      docketService.getDocketFileData(docket, function(docketFile) {
        docket.existingDocketFile = docketFile;
        cb();
      }, function(err) {
        docket.existingDocketFile = null;
        cb();
      });
    }

    /******************************/
    /***** List View Controls *****/
    /******************************/

    $scope.selectActivityForDocketFile = function(sourceList, cb) {
      $scope.viewState = 'activity';
      $scope.selectActivityCallback = cb;
      $scope.activitySelectFromParent(sourceList, function(activitySelected) {
        $scope.selectActivityCallback(activitySelected);
        $scope.viewState = 'filing';
      });
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function(message) {
      var toast = {};
      if ( $stateParams.device == 'desktop' ) {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /*********************************/
    /***** MAIN OPENING CONTROLS *****/
    /*********************************/

    $scope.filingDetailControllerReady = function() {
      if ( $stateParams.docketId != null ) {
        $scope.prepareForFilingFromParent();
        $scope.openDocketForFiling($stateParams.docketId);
      }
    }
});



// WEBPACK FOOTER //
// ./src/controllers/filing/mobileDetailController.js